import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Group } from '@era/security-sdk';
import { selectCurrentGroupId } from '../router/security-router.selector';
import * as fromMemberGroup from './member-group.reducer';
import { MemberGroupState } from './member-group.state';

export const selectMemberGroupState = createFeatureSelector<MemberGroupState>('memberGroups');

export const selectAllMemberGroups = createSelector(selectMemberGroupState, fromMemberGroup.selectAllGroups);

export const selectGroupByParentId = (parentId: string) =>
  createSelector(selectAllMemberGroups, (memberGroups: Group[]) =>
    memberGroups ? memberGroups.filter((group) => group.parentId === parentId) : []
  );

export const selectCurrentGroupChildren = createSelector(
  selectCurrentGroupId,
  selectAllMemberGroups,
  (currentGroupId: string, memberGroups: Group[]) =>
    memberGroups && currentGroupId ? memberGroups.filter((group) => group.parentId === currentGroupId) : []
);
